<div class="container-fluid" style="min-height:100%">
    <div class="header">
        <div class="d-flex justify-content-between ">
            <div>
                <p>Notifications</p>
            </div>
            <div class="cross_button" (click)="closeNotificationfun()">
                <P>+</P>
            </div>
        </div>
        <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex">
                <p [ngClass]="{'active_header': selected_nav==1}"
                    (click)="selected_nav=1;page_number = 1;type=0;filter=0;getNotifications();">All</p>
                <p [ngClass]="{'active_header': selected_nav==2}"
                    (click)="selected_nav=2;page_number = 1;type=0;filter=2;getNotifications();">Unread</p>
                <div [ngClass]="{'active_header': selected_nav==3}" class="drop_select" (click)="show_popup()">
                    {{type_Arr[type]}}<img class="ms-2 mt-1"
                        [src]="selected_nav==3?'assets/img/svg/dropdown-arrow-blue.svg':'assets/img/svg/dropdown-arrow.svg'" />
                    <div class="drop_down_popup" *ngIf="popup">
                        <p (click)="selected_nav=3;type=1;filter=0;page_number = 1; getNotifications();">Contracts</p>
                        <p (click)="selected_nav=3;type=2;filter=0;page_number = 1; getNotifications();">Claims</p>
                        <p (click)="selected_nav=3;type=3;filter=0;page_number = 1; getNotifications();">Payouts</p>
                        <p (click)="selected_nav=3;type=5;filter=0;page_number = 1; getNotifications();">Leads</p>
                        <p (click)="selected_nav=3;type=6;filter=0;page_number = 1; getNotifications();">Subscriptions</p>
                        <p *ngIf="proposal_notification_setting == 1" (click)="selected_nav=3;type=7;filter=0;page_number = 1; getNotifications();">Proposals</p>
                    </div>
                </div>
            </div>
            <div *ngIf="_main.unread_count && _main.unread_count > 0">
                <a href="javascript:void(0);" class="float-right pb-3" (click)="readNotification()">Mark all as read</a>
            </div>
        </div>

        <div class="search_container">
            <input class="form-input" trim  tabindex="-1"
                (keydown.enter)="page_number = 1;type=0;filter=0; getNotifications();selected_nav=1;" required
                [(ngModel)]="search_string" placeholder="Search">
            <label><img src="assets/img/svg/search-normal.svg"> </label>
            <span class="clear_search" [ngClass]="search_string?'d-block':'d-none'"
                (click)="search_string = ''; page_number = 1; getNotifications();">
                <img src="assets/img/svg/search-cross.svg">
            </span>
        </div>

    </div>
    <div class="list-group col p-0" style="overflow-y: auto; height:75vh;">
        <div *ngIf="notifications && notifications.length > 0" class="" (scroll)="scrollHandler()">
            <div *ngFor="let item of notifications;let i = index;"
                [ngClass]="[i < notifications.length-1 ? 'list-group-item notification_child' : 'list-group-item' ]"
                [ngStyle]="item.read_at==null?{'background-color': '#F6F9FF'} : {'background-color': 'white'}">
                <div (click)="navToNotification(item)" tappable class="d-flex" style="margin-bottom: 10px;width: 100%;">
                    <div class="w-100">
                        <div>
                            <div class="notif_header d-flex justify-content-between">
                                <h6 class="m-0 notranslate"><strong>{{item.title}}</strong></h6>
                                <p class="notification_dot" [ngClass]="{'active':item.read_at==null}"
                                    *ngIf="item.read_at==null">&#9679;</p>
                            </div>
                            <div class="mess">
                                <p class="m-0 notification-message notranslate">{{item.message}}</p>
                            </div>
                        </div>
                        <div class="time p-0">
                            <h5 class="m-0 mt-2"><small class="d-flex" style="color:#7A848D;"><img
                                src="assets/img/svg/clock.svg" class="me-2 notranslate">{{item.show_sent_at}}</small>
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
            <div id="infinite-scroller"></div>
        </div>
        <div class="text-center mt-4" *ngIf="!notifications || notifications.length == 0">
            <img src="assets/img/svg/NoNotification.svg">
            <p class="fs-18 fw-700 py-2">No Notification</p>
        </div>
    </div>
</div>